import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMa = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#B7312C", d: "M0 0h9v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "#006341", strokeWidth: 0.143, d: "M4.5 1.73l.746 2.297-1.953-1.42h2.414l-1.953 1.42z" }));
const ForwardRef = forwardRef(SvgMa);
const Memo = memo(ForwardRef);
export default Memo;
